import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _span;
var _excluded = ["popper"],
  _excluded2 = ["modifiers"];
import React from 'react';
import Typography from '@mui/material/Typography';
import MuiTooltip from '@mui/material/Tooltip';
import { getPlacement } from '../utils/navigation-utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Tooltip(props) {
  var arrow = props.arrow,
    children = props.children,
    description = props.description,
    label = props.label,
    maxWidth = props.maxWidth,
    _props$offsetDistance = props.offsetDistance,
    offsetDistance = _props$offsetDistance === void 0 ? -6 : _props$offsetDistance,
    _props$offsetSkidding = props.offsetSkidding,
    offsetSkidding = _props$offsetSkidding === void 0 ? 0 : _props$offsetSkidding,
    open = props.open,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'None' : _props$placement,
    slotProps = props.slotProps,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'light' : _props$variant,
    width = props.width;
  var placementValue = getPlacement(placement);
  var offset = [offsetSkidding, offsetDistance];
  var _ref = slotProps != null ? slotProps : {},
    popper = _ref.popper,
    otherSlotProps = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = popper != null ? popper : {},
    modifiers = _ref2.modifiers,
    otherPopperProps = _objectWithoutProperties(_ref2, _excluded2);
  return label || description ? /*#__PURE__*/_jsx(MuiTooltip, {
    PopperProps: {
      sx: {
        zIndex: 2005 // must be higher than Popover component
      }
    },
    arrow: arrow !== undefined ? arrow : placement !== 'None',
    componentsProps: {
      tooltip: {
        sx: _extends({}, label && {
          '.MuiTypography-root:first-child': {
            marginBottom: description ? '4px' : '0px'
          }
        }, {
          maxWidth: width ? 'none' : maxWidth,
          padding: description ? '12px !important' : '8px 12px !important',
          width: width
        })
      }
    },
    open: open,
    placement: placementValue,
    slotProps: _extends({
      popper: _extends({
        modifiers: [{
          name: 'offset',
          options: {
            offset: offset
          }
        }].concat(_toConsumableArray(modifiers != null ? modifiers : []))
      }, otherPopperProps)
    }, otherSlotProps),
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [label ? /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-xs-bold",
        children: label
      }) : _span || (_span = /*#__PURE__*/_jsx("span", {})), description && /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-xs-light",
        children: description
      })]
    }),
    variant: variant,
    children: children
  }) : children;
}